<template>
  <tr v-if="userGroup">
    <td class="user-group">{{ userGroup.name }}</td>
    <td class="number">{{ applications }}</td>
    <td v-for="(jobType, i) in jobTypes" :key="i" class="number">
      {{ byJobType[jobType] || 0 }}
    </td>
  </tr>
</template>
<script>
import gql from "graphql-tag";

export default {
  props: {
    id: {
      required: true
    },
    applications: {
      type: Number,
      required: true
    },
    jobTypes: {
      type: Array,
      default: () => []
    },
    byJobType: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { userGroup: null };
  },
  apollo: {
    userGroup: {
      query: gql`
        query UserGroup($id: ID!) {
          userGroup(id: $id) {
            id
            name
          }
        }
      `,
      variables() {
        return {
          id: this.id
        };
      }
    }
  }
};
</script>
<style scoped>
.user-group {
  width: 10ch;
}
.number {
  width: 10ch;
}
.data-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
